import { db } from "../../firebase";
import { collection, doc, setDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

export const createSubCollectionInClient = async (documents) => {
  /**
   * documents input format is [[*, *], [*, *], [*, *]]
   */
  try {
    const clientDocument = await doc(db, "clients", getLocalStorageItem("bid"));
    const subCollection = await collection(clientDocument, "dynamicFields");
    for (let index = 0; index < documents.length; index++) {
      const arr = documents[index];
      setDoc(doc(subCollection, arr[0]), arr[1]);
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
